import axios from "axios";
import config from "../../config";

const BASE_API = config.BASE_API;

const getReport = async (params) => {
  return axios
    .get(`${BASE_API}bloqueios/desbloqueados/relatorio`, {
      params,
      responseType: "blob",
    })
    .then((resp) => resp.data)
    .catch((error) => {
      if (error.response) {
        const mensagemErro = error.response.data?.message || "Erro desconhecido.";
        return Promise.reject(mensagemErro);
      } else {
        return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
      }
    });
};

const getReportDocx = async (params) => {
      
      return axios
        .get(`${BASE_API}bloqueios/desbloqueados/relatorio-word`, {
          params,
          responseType: "blob",
        })
        .then((resp) => resp.data)
        .catch((error) => {
          if (error.response) {
            const mensagemErro = error.response.data?.message || "Erro desconhecido.";
            return Promise.reject(mensagemErro);
          } else {
            return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
          }
        });
    };

    const getReportCsv = async (params) => {
      return axios
      .get(`${BASE_API}bloqueios/desbloqueados/relatorio-csv`, {
        params,
        responseType: "blob",
      })
      .then((resp) => resp.data)
      .catch((error) => {
        if (error.response) {
          const mensagemErro = error.response.data?.message || "Erro desconhecido.";
          return Promise.reject(mensagemErro);
        } else {
          return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
        }
      });
    };

    const sendEmail = async (params) => {
      try {
        const response = await axios.post(
          `${BASE_API}bloqueios/desbloqueados/enviar-email`,null,
          {params}
        );
        return response;
      } catch (error) {
        if (error.response) {
          const mensagemErro = error.response.data?.message || "Erro desconhecido.";
          return Promise.reject(mensagemErro); 
        } else if (error.request) {
          return Promise.reject("Erro ao gerar relatório e Enviar E-mail: Problema de conexão.");
        } else {
          return Promise.reject("Erro desconhecido.");
        }
      }
    };
    
export default {
  getReport,
  sendEmail,
  getReportDocx,
  getReportCsv,
};
